import Cookies from 'js-cookie'
import defaultSettings from '@/settings'
import store from '@/store'

const { sideTheme, showSettings, topNav, tagsView, fixedHeader, sidebarLogo, dynamicTitle } = defaultSettings

const storageSetting = JSON.parse(localStorage.getItem('layout-setting')) || ''

const app = {
    namespaced: true,
    state: {
      title: '',
      theme: storageSetting.theme || '#409EFF',
      sideTheme: storageSetting.sideTheme || sideTheme,
      showSettings: showSettings,
      topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
      tagsView: storageSetting.tagsView === undefined ? tagsView : storageSetting.tagsView,
      fixedHeader: storageSetting.fixedHeader === undefined ? fixedHeader : storageSetting.fixedHeader,
      sidebarLogo: storageSetting.sidebarLogo === undefined ? sidebarLogo : storageSetting.sidebarLogo,
      dynamicTitle: storageSetting.dynamicTitle === undefined ? dynamicTitle : storageSetting.dynamicTitle,
      sidebar: {
        opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
        withoutAnimation: false,
        hide: false
      },
    },
    mutations: {
      TOGGLE_SIDEBAR: state => {
        if (state.sidebar.hide) {
          return false;
        }
        state.sidebar.opened = !state.sidebar.opened
        state.sidebar.withoutAnimation = false
        // 只有当 functional cookies 被允许时，才保存 sidebarStatus 到 cookies
        const functionalConsent = store.state.cookie?.consent?.functional || false;
        if (functionalConsent) {
          if (state.sidebar.opened) {
            Cookies.set('sidebarStatus', 1)
          } else {
            Cookies.set('sidebarStatus', 0)
          }
        }
      },
      SET_TITLE: (state, title) => {
        state.title = title
      },
      CHANGE_SETTING: (state, { key, value }) => {
        if (state.hasOwnProperty(key)) {
          state[key] = value
        }
      },
    },
    actions: {
      toggleSideBar({ commit }) {
        commit('TOGGLE_SIDEBAR')
      },
      // 修改布局设置
      changeSetting({ commit }, data) {
        commit('CHANGE_SETTING', data)
      },
      // 设置网页标题
      setTitle({ commit }, title) {
        commit('SET_TITLE', title)
      }
    }
  }
  
  export default app
  